import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onGenerateProperty"];
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BodySmall, ButtonIconBreeze, Heading, LayoutBox, LayoutHorizontal, LayoutSpaceVertical, LayoutTileTinted } from 'breeze-intelligence-kit';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GenerateProperty = _ref => {
  let {
      onGenerateProperty
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [property, setProperty] = useState('');
  const handleGenerateProperty = async () => {
    await onGenerateProperty({
      property
    });
  };
  const handleChange = event => {
    setProperty(event.target.value);
  };
  return /*#__PURE__*/_jsx(LayoutTileTinted, Object.assign({}, rest, {
    border: "none",
    children: /*#__PURE__*/_jsxs(LayoutSpaceVertical, {
      gap: "space",
      children: [/*#__PURE__*/_jsxs(LayoutSpaceVertical, {
        as: "header",
        gap: "space-xxs",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h5",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "smartPropertyGenerate.title"
          })
        }), /*#__PURE__*/_jsx(BodySmall, {
          as: "div",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "smartPropertyGenerate.subtitle"
          })
        })]
      }), /*#__PURE__*/_jsx(LayoutBox, {
        background: "background-color-light",
        children: /*#__PURE__*/_jsx(TextArea, {
          onChange: handleChange,
          placeholder: I18n.text('smartPropertyGenerate.placeholder'),
          rows: 5,
          value: property
        })
      }), /*#__PURE__*/_jsx(LayoutHorizontal, {
        as: "footer",
        justifyContent: "end",
        children: /*#__PURE__*/_jsx(ButtonIconBreeze, {
          onClick: () => {
            void handleGenerateProperty();
          },
          variant: "secondary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "smartPropertyGenerate.cta"
          })
        })
      })]
    })
  }));
};